export default function StoryProgress({ chapters, activeIndex, total }) {
  const current = Math.min(activeIndex + 1, chapters.length)
  const active = chapters[Math.min(activeIndex, chapters.length - 1)]

  return (
    <aside className={`story-progress story-progress--${active.theme}`} aria-label="页面进度">
      <div className="story-progress__numbers" aria-hidden="true">
        <span>{String(current).padStart(2, '0')}</span>
        <span>{String(chapters.length).padStart(2, '0')}</span>
      </div>
      <div className="story-progress__track" aria-hidden="true">
        <span style={{ '--story-progress': total }} />
      </div>
      <span className="story-progress__label">{active.nav}</span>
    </aside>
  )
}
